<template>
    <iframe
        ref="iframe"
        class="w-100"
        frameborder="0"
        scrolling="x"
        sandbox="allow-scripts allow-popups allow-top-navigation allow-same-origin"
    />
</template>

<script>
export default {
    props: ['modelValue', 'id'],
    mounted () {
        window.addEventListener('message', (evt) => {
            if (!evt.data.type
                || evt.data.type !== 'heightChange'
                || evt.data.id !== this.id
                || !this.$refs.iframe) {
                return;
            }

            this.$refs.iframe.style.height = `${evt.data.value + 16}px`;
        });

        let doc = this.modelValue;
        doc += '<style>body {margin:0;padding:0;font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:0.875rem;} p { margin: 0; }</style>';
        doc += `${'&gt;script>\n'.replace('&gt;', '<')
        }            resize = function() {\n`
        + `              parent.postMessage({type:"heightChange", value:document.body.clientHeight, id:${this.id}}, "*")\n`
        + `            };\n`
        + `\n`
        + `            resize();\n`
        + `\n`
        + `            const images = document.body.getElementsByTagName("img");\n`
        + `             for(let i = 0; i < images.length; i++) {\n`
        + `                 images[i].addEventListener("load", resize);\n`
        + `             }\n`
        + `\n`
        + `            const anchors = document.body.getElementsByTagName("a");\n`
        + `            for(let i = 0; i < anchors.length; i++) {\n`
        + `                anchors[i].setAttribute("target", "_top");\n`
        + `            }\n${
            '        &gt;/script>'.replace('&gt;', '<')}`;

        // Point all links to new page
        this.$refs.iframe.setAttribute('srcdoc', doc);
    },
};
</script>
